import { combineSlices } from "@reduxjs/toolkit";
import loginReducer from "./login/loginSlice";
import doctorAppointmentsReducer from "./appointments/doctorAppointmentsSlice";import fetchDoctorAppointmentsReducer from "./appointments/doctorAppointmentsSlice";
import updateOnsiteScheduleReducer from "./updateOnsiteSchedule/updateOnsiteScheduleSlice";
import requestAppointmentRescheduleReducer from "./requestAppointmentReschedule/requestAppointmentRescheduleSlice";
import createFollowupAppointmentReducer from "./createFollowupAppointment/createFollowupAppointmentSlice";
import therapistManagementReducer from "./therapistManagement/therapistManagementSlice";
import notificationsReducer from "./notifications/notificationsSlice";
import earningsMetricsReducer from "./earnings/earningsMetricsSlice";
import earningsListReducer from "./earnings/earningsListSlice";
import pendingOrdersReducer from "./dashboard/pendingOrdersSlice";
import ongoingOrdersReducer from "./dashboard/ongoingOrdersSlice";
import payoutAccountReducer from "./payoutAccount/payoutAccountSlice";

export default combineSlices({ 
    login: loginReducer,
    appointments: doctorAppointmentsReducer,
    fetchDoctorAppointments: fetchDoctorAppointmentsReducer,
    updateOnsiteSchedule: updateOnsiteScheduleReducer,
    requestAppointmentReschedule: requestAppointmentRescheduleReducer,
    createFollowupAppointment: createFollowupAppointmentReducer,
    therapistManagement: therapistManagementReducer,
    notifications: notificationsReducer,
    earningsMetrics: earningsMetricsReducer,
    earningsList: earningsListReducer,
    pendingOrders: pendingOrdersReducer,
    ongoingOrders: ongoingOrdersReducer,
    payoutAccount: payoutAccountReducer,
});